// API for aggregated QR landing page data
import { API_BASE_URL, getUserDepartment } from "./base";

const getApiHeaders = () => {
  const userDepartment = getUserDepartment();
  return {
    "Content-Type": "application/json",
    "X-User-Department": userDepartment,
  };
};

export const apiGetQrAkaun = async (noAkaun) => {
  const response = await fetch(
    `${API_BASE_URL}/qr/akaun/${encodeURIComponent(noAkaun)}`,
    { method: "GET", headers: getApiHeaders(), credentials: 'include' }
  );
  if (!response.ok) {
    const text = await response.text();
    throw new Error(`QR Akaun fetch failed: ${response.status} ${text}`);
  }
  return response.json();
};
